
import { Injectable, ComponentRef, ViewContainerRef, Type } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class TabComponentLoader {
  private containers: { [key: string]: ViewContainerRef } = {};

  registerContainer(key: string, container: ViewContainerRef) {
    this.containers[key] = container;
  }

  unregisterContainer(key: string) {
    delete this.containers[key];
  }

  loadComponent(key: string, component: Type<any>): ComponentRef<any> | undefined {
    const container = this.containers[key];
    if (container) {
      if (container.length > 0) { // if component is already loaded
        return;
      }
      container.clear();
      return container.createComponent(component);
    }
    return undefined;
  }
}
